export type ParsedBookingTime = {
  hour24: number;
  hour12: number;
  minute: number;
  period: "am" | "pm";
};

/**
 * Parse a booking wall-clock time in either 24-hour (`14:00`) or
 * 12-hour (`2:00 pm`) form. Invalid or ambiguous values are rejected.
 */
export function parseBookingTime(value: string): ParsedBookingTime | null {
  const match = value.trim().match(/^(\d{1,2}):(\d{2})(?:\s*(am|pm))?$/i);
  if (!match) return null;

  const rawHour = Number(match[1]);
  const minute = Number(match[2]);
  const suppliedPeriod = match[3]?.toLowerCase() as "am" | "pm" | undefined;
  if (!Number.isInteger(rawHour) || !Number.isInteger(minute) || minute > 59) return null;
  if (suppliedPeriod ? rawHour < 1 || rawHour > 12 : rawHour < 0 || rawHour > 23) return null;

  let hour24 = rawHour;
  if (suppliedPeriod === "pm" && rawHour !== 12) hour24 += 12;
  if (suppliedPeriod === "am" && rawHour === 12) hour24 = 0;

  const period = hour24 >= 12 ? "pm" : "am";
  return {
    hour24,
    hour12: hour24 % 12 || 12,
    minute,
    period,
  };
}